import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { C4ListResponse, ProjectDTO, RestService } from 'cargo-chief-commons';
import { UtilService } from '@service/util/util.service';
import { UrlService } from '@service/url/url.service';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';

import { MtxPopoverTrigger } from '@ng-matero/extensions/popover';
import { getProjectsFilters } from '../../v2/utils/projects-list';
import { buildRequest } from '../../v2/procurement/procurement-list/build-projects-request';

@Component({
	selector: 'app-project-selector',
	templateUrl: './project-selector.component.html',
	styleUrls: ['./project-selector.component.scss'],
})
export class ProjectSelectorComponent implements OnInit {
	@Input() accountId: number;
	@Input() labelAlignment: string = 'center center';

	@Output() projectSelectedEvent: EventEmitter<ProjectDTO> = new EventEmitter();
	@ViewChild(MtxPopoverTrigger) trigger: MtxPopoverTrigger;

	searchText;
	projects: Array<ProjectDTO> = null;
	selectedProject: ProjectDTO = null;
	hasNextPage: boolean = false;
	isLoadingProjectsList: boolean = false;
	page = 0;
	pageSize = 20;

	constructor(
		public utilService: UtilService,
		private restService: RestService,
		private urlService: UrlService,
		private accountSettingsService: AccountSettingsService,
		private cargochief: Cargochief
	) {}

	ngOnInit() {
		this.getProjects();
	}

	viewMoreProjects() {
		this.page += 1;
		this.getProjects();
	}

	getProjects() {
		this.isLoadingProjectsList = true;
		const filteredFilters = getProjectsFilters(
			[],
			this.accountSettingsService,
			this.utilService.isUserRoleAdmin(),
			this.cargochief.USER_ID
		);
		let request = buildRequest(
			this.cargochief.ACCOUNT_ID,
			this.accountSettingsService.ANNUAL_VOLUME,
			filteredFilters || [],
			this.page,
			this.pageSize,
			'created',
			'desc',
			[],
			this.cargochief.USER_ID,
			[],
			[]
		);

		const url = this.urlService.getProjectsList();
		this.restService.POST(url, request).subscribe(
			(response: C4ListResponse<ProjectDTO>) => {
				if (this.projects) {
					this.projects = this.projects.concat(response.data);
				} else {
					this.projects = response.data;
				}
				this.hasNextPage = response.nextPage;
				this.isLoadingProjectsList = false;
			},
			(error) => {
				this.projects = [];
				this.isLoadingProjectsList = false;
			}
		);
	}

	projectSelected(project: ProjectDTO) {
		this.selectedProject = project;
		this.projectSelectedEvent.emit(project);
		this.trigger.closePopover();
	}

	projectCleared() {
		this.selectedProject = null;
		this.projectSelectedEvent.emit(null);
	}
}
